const ed5gt = () => {
   return (
      <p>                    
         <strong>Дуоденоскоп ED-5GT</strong>
         <br /><br /> 
         • Поле зрения 100°<br /> 
         • Угол зрения назад 15°<br /> 
         • Глубина резкости 4-60 мм<br /> 
         • Диаметр дистального конца 13,5 мм<br /> 
         • Диаметр вводимой части 11,3 мм<br /> 
         • Диаметр инструментального канала 4,2 мм<br /> 
         • Изгиб дистального конца:<br /> 
         • Вверх / Вниз 120° / 90°<br /> 
         • Влево / Вправо 90° / 100°<br /> 
         • Рабочая длина 1250 мм<br /> 
         • Совместимость HD-550, HD-500<br /> 
         <br />                                        
      </p> 
   );
}

export default ed5gt;